import { zodContract } from '@leprecoins/effector-sockets';
import { createReceive } from '../socket-client';
import { shiftTotalSchema } from '../types';

export const receiveShiftOpened = createReceive('shift-opened', zodContract(shiftTotalSchema));
